const ADMIN_AUTH_CACHE_TTL_MS = 5 * 60 * 1000

let authenticateInFlight: Promise<void> | null = null
let cachedAuthToken = ''
let cachedAuthAt = 0

export const ADMIN_AUTH_TTL_MS = ADMIN_AUTH_CACHE_TTL_MS

export const resolveAdminAuthToken = (): string => {
  const sessionData = sessionStorage.getItem('impersonation_session')
  if (sessionData) {
    return sessionStorage.getItem('impersonation_token') || ''
  }

  return sessionStorage.getItem('admin_token') || localStorage.getItem('admin_token') || ''
}

export const shouldSkipAdminAuthenticate = (
  hasUserName: boolean,
  force: boolean,
): boolean => {
  if (force) return false

  const token = resolveAdminAuthToken()
  return Boolean(
    hasUserName
    && token
    && cachedAuthToken === token
    && Date.now() - cachedAuthAt < ADMIN_AUTH_CACHE_TTL_MS,
  )
}

export const getAdminAuthenticateInFlight = (): Promise<void> | null => authenticateInFlight

export const setAdminAuthenticateInFlight = (promise: Promise<void> | null): void => {
  authenticateInFlight = promise
}

export const markAdminAuthCacheSuccess = (token: string): void => {
  cachedAuthToken = token
  cachedAuthAt = Date.now()
}

/** Invalide le cache authenticate/all/playphoto du store admin (ex. 401, logout). */
export const invalidateAdminAuthCache = (): void => {
  authenticateInFlight = null
  cachedAuthToken = ''
  cachedAuthAt = 0
}
